import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Eye, EyeOff, User } from 'lucide-react';
import "./Login.css";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const response = await axios.post("/login-new", {
        email,
        password,
      });

      const { accessToken, user, permissionData, userType } = response.data;

      // Store all necessary data in localStorage sequentially
      await Promise.all([
        localStorage.setItem("d4uToken", accessToken),
        localStorage.setItem("userData", JSON.stringify(user)),
        localStorage.setItem("userType", userType),
        localStorage.setItem("roleData", JSON.stringify(permissionData)),
      ]);


      console.log("=======user type====", userType)
      // Navigate based on user type after storage is done
      switch (userType) {
        case "admin":
          navigate("/dashboard");
          break;
        case "agent":
          navigate("/dashboardAgent");
          break;
        case "subAgent":
          navigate("/dashboardSubAgent");
          break;
        case 'ambulance_company':
          navigate('/dashboardForAmbulanceComapny');
          break;
        case 'callcenter':
          navigate('/dispatch');
          break;
        default:
          navigate("/dashboard");
      }
      window.location.reload();

    } catch (err) {
      setError(err.response?.data?.msg || "Invalid credentials");
    } finally {
      setLoading(false);
    }
  };


  return (
    <div className="login-wrapper">
      <div className="login-container">
        <div className="login-left">
          <div className="login-left-content">
            <h1>ለAmbulance</h1>
            <p>TirtaMed Plc & eTech S.C.</p>

          </div>
        </div>

        <div className="login-right">
          <div className="login-form-wrapper">
            <h2>Welcome Back</h2>
            <p className="login-subtitle">Sign in to continue</p>

            {error && <div className="error-alert">{error}</div>}

            <form onSubmit={handleLogin}>
              <div className="form-group">
                <label>Email</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email"
                  required
                />
              </div>

              <div className="form-group">
                <label>Password</label>
                <div style={{ position: 'relative' }}>
                  <input
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Enter your password"
                    required
                    style={{ paddingRight: '40px' }}
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    style={{
                      position: 'absolute',
                      right: '10px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      background: 'none',
                      border: 'none',
                      cursor: 'pointer',
                      color: '#666',
                      padding: 0,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                  </button>
                </div>
              </div>

              <div className="form-footer">
                <label className="checkbox-container">
                  <input type="checkbox" />
                  <span className="checkbox-text">Remember me</span>
                </label>
                <a href="/passwordResetAdmin" className="forgot-link">
                  Forgot Password?
                </a>
              </div>

              <button
                type="submit"
                className="login-button"
                disabled={loading}
              >
                {loading ? "Signing in..." : "Sign In"}
              </button>
            </form>

            {/* <div className="emergency-contact-info">
              <p>Emergency Contact: <strong>939</strong> or <strong>907</strong></p>
            </div> */}

            <div className="public-actions" style={{ marginTop: 16 }}>
              <hr style={{ margin: '16px 0', opacity: 0.2 }} />
              <p className="login-subtitle" style={{ marginBottom: 8 }}>Are you an ambulance provider?</p>
              <a href="/ambulance-company/register" className="login-button" style={{ display: 'inline-block', textDecoration: 'none', textAlign: 'center' }}>
                Register your ambulance company
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* ── Floating passenger portal shortcut ── */}
      <button
        id="passenger-portal-shortcut"
        onClick={() => navigate("/passenger/login")}
        style={{
          position: 'fixed',
          bottom: 28,
          right: 28,
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          padding: '11px 20px',
          background: 'linear-gradient(135deg, #0f172a 0%, #1e40af 100%)',
          color: 'white',
          border: 'none',
          borderRadius: '100px',
          fontSize: '0.875rem',
          fontWeight: 700,
          cursor: 'pointer',
          boxShadow: '0 4px 20px rgba(30,64,175,0.35)',
          letterSpacing: '0.01em',
          transition: 'all 0.2s ease',
          zIndex: 999,
          fontFamily: 'inherit',
        }}
        onMouseEnter={e => {
          e.currentTarget.style.transform = 'translateY(-2px)';
          e.currentTarget.style.boxShadow = '0 8px 28px rgba(30,64,175,0.45)';
        }}
        onMouseLeave={e => {
          e.currentTarget.style.transform = 'translateY(0)';
          e.currentTarget.style.boxShadow = '0 4px 20px rgba(30,64,175,0.35)';
        }}
      >
        <span style={{
          width: 26, height: 26, background: 'rgba(255,255,255,0.15)',
          borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          <User size={14} />
        </span>
        Passenger Portal
      </button>
    </div>
  );
};

export default Login;
